import { Injectable } from '@angular/core';
import { BaseController, Params } from '@app/common/modules/base/base.controller';
import { FaturamentoModel } from '@app/data/faturamento/models';
import { FaturamentoRepository } from '@app/data/faturamento/faturamento.repository';
import { Observable, map } from 'rxjs';

@Injectable()
export class FaturamentoController extends BaseController<FaturamentoModel> {
  constructor(faturamentoRepository: FaturamentoRepository) {
    super(faturamentoRepository);
  }

  override getPaginated(
    params: Params,
  ): Observable<{ data: { results: FaturamentoModel[]; count: number } }> {
    return this.repository
      .getRequest<{ data: { results: FaturamentoModel[]; count: number } }>(params)
      .pipe(
        map((response) => {
          response.data.results = response.data.results.map((item) => ({
            ...item,
            fatura: item.notaFiscal || item.notaDebito || item.recibo,
          }));

          return response;
        }),
      );
  }
}
